/**
 * @module Breadcrumbs
 */

import Component from '../Component';
import './styles.css';

/**
 * Хлебные крошки.
 */
export default class Breadcrumbs extends Component {
    static className = 'breadcrumbs';
}
